import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import MenuView from "./MenuView";
import ListView from "../ListView";
import PracticeView from "../practice/PracticeView";
import RulesView from "../RulesView";
import SearchView from "../search/SearchView";
import HomeView from "../HomeView";
import ContactView from '../ContactView';
import MobileView from '../MobileView';
import { DataContext } from "../../store/DataProvider";


class ContentView extends Component {
	static contextType = DataContext;

	constructor(props) {
		super(props);
		this.state = {
			section: props.section,
			system: "full",
			pitch: "",
			sharp: false,
			category: "",
			rule_category: ""
		}
		this.updateMenu = this.updateMenu.bind(this)
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.section !== prevProps.section) {
			this.setState({ section: this.props.section })
			this.setState({ category: "" })
		}
	}

	updateMenu(system, category, pitch = "", sharp = "", rule_category = "") {
		this.setState({ system: system })
		this.setState({ category: category })
		this.setState({ pitch: pitch })
		this.setState({ sharp: sharp })
		this.setState({ rule_category: rule_category })
		document.getElementById("main").focus();
	}

	renderContentSection() {
		switch (this.state.section) {
			case "home":
				return (
					<HomeView />
				)
			case "lists":
				return (
					<ListView system={this.state.system} category={this.state.category} pitch={this.state.pitch}
						sharp={this.state.sharp}></ListView>
				)
			case "practices":
				return (
					<PracticeView system={this.state.system} category={this.state.category}></PracticeView>
				)
			case "rules":
				return (
					<RulesView system={this.state.system} index={this.state.category}
						category={this.state.rule_category}></RulesView>
				)
			case "search":
				return (
					<SearchView system={this.state.system}></SearchView>
				)
			case "contact":
				return (
					<ContactView />
				)
			default:
				return (
					<div></div>
				)
		}
	}
	renderMenu() {
		if (this.state.section !== 'home' && this.state.section !== 'contact') {
			return (
				<div className='col-3'>
					<MenuView section={this.state.section} onMenuClick={this.updateMenu} />
				</div>
			)
		}
	}

	render() {
		return (
			<div>
				<div className="row justify-content-center h-100 desktop_div">
					{this.renderMenu()}
					<div className="col h-100">
						<main id="main">
							{
								this.renderContentSection()
							}
						</main>
					</div>
				</div>
				<div className='mobile_div'>
					<MobileView />
				</div>
			</div>
		)
	}
}

export default withTranslation()(ContentView);